import { render, staticRenderFns } from "./list-drafts.vue?vue&type=template&id=7d822cce&lang=pug&"
import script from "./list-drafts.vue?vue&type=script&lang=js&"
export * from "./list-drafts.vue?vue&type=script&lang=js&"
import style0 from "./list-drafts.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports